import React, { useRef } from "react";
import { PiCheckCircleBold } from "react-icons/pi";
import { RxCross2 } from "react-icons/rx";
import { Image, Button } from "antd";
import { MdOutlineFileDownload, MdUpload } from "react-icons/md";

const AnswerList = ({
  answers = [],
  onAnswerChange,
  onImageUpload,
  onImageRemove,
  canEdit = false,
  surveyTemplate,
}) => {
  const fileInputRefs = useRef({});

  const handleChange = (uuid, value) => {
    onAnswerChange?.(uuid, value);
  };

  const handleFileChange = (uuid, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Create object URL for preview
    const imageUrl = URL.createObjectURL(file);

    // Call the upload handler
    onImageUpload?.(uuid, file, imageUrl, "true");

    // Reset the file input
    if (fileInputRefs.current[uuid]) {
      fileInputRefs.current[uuid].value = '';
    }
  };

  const triggerFileInput = (uuid) => {
    if (fileInputRefs.current[uuid]) {
      fileInputRefs.current[uuid].click();
    }
  };

  const downloadImages = (imageUrl, e) => {
    e.preventDefault();
    window.open(imageUrl, "_blank", "noopener,noreferrer");
  };

  const getQuestionDetails = (uuid) => {
    const question = surveyTemplate?.customSurvey?.find((q) => q.uuid === uuid);
    return {
      type: question?.type || "text",
      options: Array.isArray(question?.options)
        ? question.options
        : Object.values(question?.options || {}),
      required: String(question?.require_response || question?.requireResponse || "")
        .toLowerCase() === "true",
    };
  };

  return (
    <>
      {answers.map((answer, index) => {
        const { question, answer: value, image, geotag, uuid } = answer;
        const questionDetails = getQuestionDetails(uuid);
        const { type, options, required } = questionDetails;

        // ✅ FIX: Only show geotagged if geotag is explicitly "true"
        const isGeotagged = geotag === "true";

        return (
          <div className="row mt-3" key={uuid || index}>
            <div className="tupdate">
              {question}
              {required && <span style={{ color: "#d00", marginLeft: 6 }}>*</span>}
              {/* ✅ FIX: Only show geotagged badge when actually geotagged */}
              {isGeotagged && (
                <span className="ms-3 geocls">
                  <PiCheckCircleBold />{" "}
                  <span className="text-dark" style={{ fontSize: "12px" }}>
                    Geotagged
                  </span>
                </span>
              )}
            </div>

            <div className="mt-1" style={{ fontSize: "14px" }}>
              {type === "dropdown" ? (
                <select
                  className="form-select"
                  value={value || ""}
                  onChange={(e) => handleChange(uuid, e.target.value)}
                  disabled={!canEdit}
                >
                  <option value="">Select</option>
                  {options.map((opt, i) => (
                    <option key={i} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              ) : type === "text" ? (
                <input
                  type="text"
                  className="form-control"
                  value={value || ""}
                  onChange={(e) => handleChange(uuid, e.target.value)}
                  disabled={!canEdit}
                  placeholder={required ? "Required field" : "Enter response"}
                />
              ) : (
                <input
                  type="text"
                  className="form-control"
                  value={value || ""}
                  onChange={(e) => handleChange(uuid, e.target.value)}
                  disabled={!canEdit}
                  placeholder={required ? "Required field" : "Enter response"}
                />
              )}
            </div>

            {/* IMAGE UPLOAD/DISPLAY */}
            {type === "image" && (
              <div className="mt-2">
                {!image && canEdit && (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={el => fileInputRefs.current[uuid] = el}
                      onChange={(e) => handleFileChange(uuid, e)}
                      style={{ display: 'none' }}
                    />
                    <Button
                      type="primary"
                      icon={<MdUpload />}
                      onClick={() => triggerFileInput(uuid)}
                      disabled={!canEdit}
                    >
                      Upload Image
                    </Button>
                  </div>
                )}

                {image && (
                  <div className="position-relative" style={{ display: 'inline-block' }}>
                    {canEdit && (
                      <RxCross2
                        onClick={() => onImageRemove?.(answer)}
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          right: '-10px',
                          top: '-10px',
                          zIndex: 1,
                          background: 'white',
                          borderRadius: '50%',
                          padding: '4px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                          fontSize: '16px',
                          color: '#ff4d4f'
                        }}
                      />
                    )}
                    <Image.PreviewGroup items={[image]}>
                      <Image
                        width={190}
                        src={image}
                        style={{ borderRadius: "20px", border: '1px solid #d9d9d9' }}
                      />
                    </Image.PreviewGroup>
                    <div
                      onClick={(e) => downloadImages(image, e)}
                      className="imgdownload"
                      style={{
                        cursor: 'pointer',
                        marginTop: '8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        color: '#1890ff'
                      }}
                    >
                      Download <MdOutlineFileDownload style={{ fontSize: "16px" }} />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default AnswerList;
